import { TranslateHelper } from './../../_helpers/translate-helper';
import { SharedService } from '@app/_services/shared.service';
import { Component, Input, NgZone, AfterViewInit, ViewChild, ChangeDetectorRef, OnInit, Inject, PLATFORM_ID } from '@angular/core';
import { CurrencyService } from '@services/currency.service';
import { HomepageService } from '@app/_services/homepage.service';
import { Router, ActivatedRoute, RouterLink } from '@angular/router';
import { MatTabGroup as MatTabGroup } from '@angular/material/tabs';
import { UntypedFormControl } from '@angular/forms';
import { DirectionService } from '@app/_services/direction.service';
import { CarouselComponent, CarouselModule } from 'ngx-owl-carousel-o';
import * as _ from 'lodash';
import { TranslateService } from '@ngx-translate/core';
import { Support } from '@app/_helpers';
import { isPlatformBrowser, NgIf, NgFor } from '@angular/common';
import { OwlPreventClickDirective } from '../../shared/directives/owl-prevent-click.directive';

@Component({
    selector: 'app-header-topbar',
    templateUrl: './topbar.component.html',
    styleUrls: ['./topbar.component.scss'],
    providers: [TranslateHelper],
    standalone: true,
    imports: [NgIf, CarouselModule, OwlPreventClickDirective, NgFor, RouterLink]
})
export class TopbarComponent implements AfterViewInit {
    @Input() categories = [];
    selectedSector;
    selected = new UntypedFormControl(0);

    carouselOptions = {
        touchDrag: true,
        mouseDrag: true,
        skip_validateItems: true,
        margin: 8,
        dots: false,
        autoWidth: true,
        rtl: this.direction.isRTL()
    };
    constructor(
        public currencyService: CurrencyService,
        private homepageService: HomepageService,
        private zone: NgZone,
        private router: Router,
        private route: ActivatedRoute,
        public sharedService: SharedService,
        private cd: ChangeDetectorRef,
        public translateHelper: TranslateHelper,
        public direction: DirectionService,
        private translate: TranslateService,
        @Inject(PLATFORM_ID) private platformId: any

    ) {

        this.sharedService.pageSubject$.subscribe(response => {
            this.selectedSector = response;
            if (response == 'homepage')
                this.selected.setValue(0)
        })
        //this.selectedSector = sharedService.page;

    }
    ngOnInit(): void {

    }


    items = []
    @ViewChild("tabGrp", { static: false }) tab: MatTabGroup;


    tabs = ['First', 'Second', 'Third'];

    addTab(selectAfterAdding: boolean) {
        this.tabs.push('New');

        if (selectAfterAdding) {
            this.selected.setValue(this.tabs.length - 1);
        }
    }

    removeTab(index: number) {
        this.tabs.splice(index, 1);
    }

    ngAfterViewInit(): void {
        this.categories = [];
        this.homepageService.categories$.subscribe(data => {
            if (!data) return;
            this.categories = data;
            if (this.selectedSector && this.selectedSector != 'homepage') {
                let index = this.categories.findIndex(item => item.seo?.slug == this.selectedSector);
                if (index >= 0 && index <= this.categories.length + 1) {
                    this.selected.setValue(index + 1);
                }
                else this.selected.setValue(0);
            }
            if (isPlatformBrowser(this.platformId)) {
                _.forEach(this.categories, (sector, key) => {
                    let element = document.createElement('canvas');
                    let context = element.getContext("2d");
                    context.font = "15px Lato, sans-serif";
                    let fontSize = context.measureText(sector.name[this.translate.currentLang]).width;
                    this.categories[key].width = fontSize + 55;
                })

            }
            this.cd.detectChanges();
        });
    }

    selectSector(sector) {
        if (!sector?.seo?.slug) return false;
        this.sharedService.pageSubject$.next(sector?.seo?.slug);
        // this.router.navigate(['/sector', sector?.seo?.slug])
    }

    selectionChange(event) {
        this.sharedService.currentCategorySubject$.next(null);
        this.selectSector(event);
        //this.cd.detectChanges();
    }

    setPage(owlCar) {
        owlCar.to(this.selectedSector);
    }


}
